<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('REQUEST_VACATIONS.ITEM') }}
      </span>

      <v-spacer />
      <div>
        <v-select
          v-model="form.status_id"
          solo
          flat
          :items="statuses"
          item-value="id"
          item-text="name"
          small-chips
          hide-details
          dense
          style="width: 150px"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              small
              :color="item.color"
              dark
              class="ml-1"
              v-bind="attrs"
              :input-value="selected"
              @click="select"
            >
              {{ item.name }}
            </v-chip>
          </template>
        </v-select>
      </div>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col cols="5">
          <request-vacation-detail :request-vacation="form" class="pa-4 mb-4" />
        </v-col>
        <v-col cols="7"
          ><v-form ref="form" v-model="valid" lazy-validation>
            <request-vacation-edit-form
              v-model="form"
              :errors="errors.getAll()"
              @update-prop="clearErrorByName($event)"
            />
            <v-textarea
              v-model="form.comment"
              outlined
              name="info"
              :label="$t('REQUEST_VACATIONS.COMMENT')"
              :counter="1000"
              :rules="rules.comment"
              :error-messages="errors.info"
              :disabled="isDisabledComment()"
            />
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="update">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import RequestVacationDetail from '@/modules/request_vacations/components/RequestVacationDetail.vue';
import RequestVacationEditForm from '@/modules/request_vacations/components/forms/RequestVacationEditForm.vue';
import { RequestVacationsService } from '@/services/request-vacations.service';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';
import router from '@/router';

export default {
  name: 'EditRequestVacation',

  components: {
    RequestVacationEditForm,
    RequestVacationDetail
  },

  mixins: [errors, i18nRefreshData],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: true,
      form: {},
      statuses: [],
      rules: {
        comment: [maxLength(1000), notEmoji]
      }
    };
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('request_vacations', ['getStatuses']),

    isDisabledComment() {
      switch (this.form.status_id) {
        case 'requested':
          return false;

        case 'rejected':
          return false;

        default:
          return true;
      }
    },

    refreshData() {
      this.getDataStatuses();
    },

    getDataStatuses() {
      this.getStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    valueWatchHandler(formProps) {
      if (!formProps.id) {
        return;
      }
      this.getVRequest(formProps.id);
    },

    getVRequest(id) {
      RequestVacationsService.getById(id)
        .then(({ data }) => {
          this.form = { ...data };
        })
        .catch(this.handleErrors);
    },

    cancel() {
      this.$emit('cancel');
    },

    update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      RequestVacationsService.update(this.form.id, this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('updated', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
